import type * as translationJson from '@clientWebAssets/translations/en.json';

export type TranslationKeys = keyof typeof translationJson;

export default class TranslatorService {
  private static instance: TranslatorService | null = null;
  private translations: Promise<Partial<Record<TranslationKeys, string>>>;
  private currentLocale: string;

  private constructor(locale: string) {
    this.currentLocale = locale;
    this.translations = this.loadTranslations();
  }

  public static getInstance(): TranslatorService {
    if (!TranslatorService.instance) {
      const locale = document?.documentElement?.getAttribute('lang') ?? 'en';
      TranslatorService.instance = new TranslatorService(locale);
    }
    return TranslatorService.instance;
  }

  public async translate(key: TranslationKeys): Promise<string> {
    return (await this.translations)[key] ?? (key as string);
  }

  public getLocale(): string {
    return this.currentLocale;
  }

  private async loadTranslations(): Promise<Record<TranslationKeys, string>> {
    try {
      const translationJson = await this.fetchTranslations();
      console.log(`Translations loaded for locale '${this.currentLocale}'`);
      return translationJson;
    } catch (error) {
      console.error(`Failed to load translations for '${this.currentLocale}':`, error);
    }
  }

  private async fetchTranslations(): Promise<Record<TranslationKeys, string>> {
    try {
      const translationModule = await import(`@clientWebAssets/translations/${this.currentLocale}.json`);
      return translationModule.default || {};
    } catch (error) {
      throw new Error(`Error fetching translations for locale '${this.currentLocale}', ${error}`);
    }
  }
}
